import AnalysisModel from "@/models/lab/AnalysisModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class AnalysisCollection extends LabServiceCollection {
  model() {
    return AnalysisModel;
  }
}
